"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterAvailabilityFeature = void 0;
const react_table_1 = require("@tanstack/react-table");
exports.FilterAvailabilityFeature = {
    // define the new feature's initial state
    getInitialState: (state) => {
        return {
            filterAvailability: {},
            ...state,
        };
    },
    // define the new feature's default options
    getDefaultOptions: (table) => {
        return {
            onFilterAvailabilityChange: (0, react_table_1.makeStateUpdater)('filterAvailability', table),
        };
    },
    // define the new feature's table instance methods
    createTable: (table) => {
        table.setFilterAvailability = updater => {
            const safeUpdater = old => {
                return (0, react_table_1.functionalUpdate)(updater, old);
            };
            return table.options.onFilterAvailabilityChange?.(safeUpdater);
        };
        table.getFilterAvailability = () => table.getState().filterAvailability;
    },
};
